<template>
  <main class="home-page">
    <TopBar page-header="Startsida" />
    <div class="content"
         v-html="homeText"
    /> 
    <br>
    <button class="button"
            @click="gotoTasks()"
    >
      <div class="buttonTextContainer">
        &nbsp;
        <span class="material-icons-round">assignment</span>
        <span class="text">{{ $t('homePage.doTasks') }}</span>
        &nbsp;
      </div>
    </button> 
    <br>
    <div v-for="file in files"
         :key="file.File"
         class="filecontent"
    > 
      <a :href="`../../static/${file.File}`"
         target="_blank"
      >{{ file.Text }} 
        <span class="material-icons-outlined"> 
          {{ file.MaterialIcon }} 
        </span> 
      </a> 
    </div>
    <br>
  </main>
</template>

<script setup>
import TopBar from "../components/TopBar.vue";
import i18n from '../locales/i18n';
import { onMounted, computed } from "vue"; 
import { useStore } from "vuex"; 
import router from "@/router";

const store = useStore(); 
 
const homeText = computed(() => window?.siteConfig !== undefined ? window.siteConfig.HOMEPAGEHTML : ''); 
const files = computed(() => window?.siteConfig !== undefined ? window.siteConfig.HOMEPAGEFILES : []); 

onMounted(async () => { 
  store.commit('sidebar/setCurrentPageHeaderText', i18n.global.t('sidebar.home')); 
  console.log(homeText.value)
  console.log(files.value)
}); 

function gotoTasks(){
  router.push('/tasks')
}

</script>

<style lang="scss" scoped>
@import "../scss/buttons.scss";
.home-page {
  height: 100vh;
  overflow-y: scroll;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  background: linear-gradient(90deg, var(--gray) 0%, var(--background2) 10px);

  .button {
    @include btnBig;
    height: 40px !important;
    margin-top: 2px;
    margin-right: 0px;
    border: 1px solid var(--topbar);
    box-shadow: rgba(0, 0, 0, 0.15) 3px 3px 3px;
    padding: 0px;
    padding-bottom: 5px;
    .buttonTextContainer{
      display: flex;
      justify-content: space-evenly;
    }
    .text{
      padding-top: 0.5rem;
    }
    .material-icons-round{
      padding-top: 0.25rem;
    }
  }

  .content {
    padding: 2rem;
    text-decoration: none;
    //font-size: 20px;

    font-size: 0.9em;
    font-family: sans-serif;
    font-weight: bold;
  }
  .filecontent { 
    padding: 0.5rem; 
    text-decoration: none; 
    //font-size: 20px; 
 
    font-size: 0.9em; 
    font-family: sans-serif; 
    font-weight: bold; 
    a{ 
      font-size: 1em; 
      .material-icons-outlined{ 
        position:relative; 
        top:5px; 
      } 
    } 
  } 
  .secondRow{
    padding-top: 0px;
  }
}

    a:link { text-decoration: none;color: #2c3e50; }


    a:visited { text-decoration: none;color: #2c3e50; }



    
      a:hover{
        text-decoration: underline; 
            .material-icons-outlined {
          text-decoration: underline; 

      
      }
      }
    a:active { text-decoration: none;color: #2c3e50; }
</style>
